module.exports = __webpack_public_path__ + "static/media/no_content.4ba8614c.svg";